// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 72 ? "0b7b90cd" : chunkId) + "." + {"72":"e8010332393917f0","191":"1cd0b35e66811abf","482":"22d27cbcf49135bb"}[chunkId] + ".js";
};